import React, { useState, useEffect } from 'react';
import { Container, Button, Form, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import httpcontactus from '../js/http-lms_contactus';
// import httpuserprofile from '../../js/http-lms_userprofile';
// import httpcontactus from '../../js/http-lms_contactus';
// import { ROUTES } from '../../Constant/Routes';
// import PageSeoComponent from '../../SEO';
// import SEO from '../../Constant/SEO.json'

const Unsubscribe = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [unsubMsg, setUnsubMsg] = useState('');
  
    const handleInput = (e) => {
      setEmail(e.target.value);
      setError(''); // Clear error when user types
    };



    const handleUnsubscribe = (e) => {
      e.preventDefault();
    
      setError('');
      setUnsubMsg('');
    
      if (!email) {
        setError('Email is required');
        return;
      }
    
      httpcontactus
        .put(
          `/allContactUS/updateContextFlagInContactData`,
          {}, // Empty body for PUT
          {
            params: { email: email }, // Email as query parameter
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then((response) => {
          if (response.status === 200 || response.status === 404) {
            console.log('Response:', response.data);
            setUnsubMsg(response.data);
            setError('');
    
            // Clear message after 5 seconds
            setTimeout(() => setUnsubMsg(''), 5000);
          } else {
            setError('Unexpected response. Please try again.');
            
            // Clear error after 5 seconds
            setTimeout(() => setError(''), 5000);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          setError(error?.response?.data ?? error?.message ?? "An unexpected error occurred");


          setUnsubMsg('');
    
          // Clear error after 5 seconds
          setTimeout(() => setError(''), 5000);
        });
    };
    
      

  

  return (
    <>

{/* <PageSeoComponent {...SEO['contact-details']} /> */}

<div className="d-flex justify-content-center" style={{ position: 'relative', height: '100%', backgroundColor: '#5ecca5' }}>
<img
  src={require('../images/Goodbye.webp')}
  alt="Background"
  className="background-propertydesc-image"
  style={{ marginTop: '110px', height: '40%', width: '40%'}}
/>

<div>
</div>
        {/* <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: 'white',
            zIndex: '10',
          }}
        >
          <h1>Project Specification</h1>
        </div> */}
      </div>


      <div className='mt-5'>

      <h1 className="text-center inter black mb-4 ">
      See You Again Soon!
          </h1>

          <p className='text-center font20 inter black px-4'>"We’ll miss you! But if you ever want to stay in the loop again, we’ll be right here. Until then, take care!</p>

      </div>


      <Container className="d-flex justify-content-center my-5">
  <Form onSubmit={handleUnsubscribe} className="w-50">
    <Form.Group controlId="email">
      <Form.Label className="required">Email ID</Form.Label>
      <Form.Control
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={handleInput}
      />
      {error && <p className="text-danger mt-2">{error}</p>}
      {unsubMsg && !error && <p className="text-success mt-2">{unsubMsg}</p>}
    </Form.Group>
    <Button variant="danger" type="submit" className="mt-3 w-100">
      Unsubscribe
    </Button>
  </Form>
</Container>




    </>
  );
};

export default Unsubscribe;
